import * as yup from "yup"

export const max = {
  fullname: [50, "ניתן להזין עד 50 תווים"] as [number, string],
}

export const required = {
  default: "שדה זה הינו שדה חובה",
  firstName: "יש להזין שם פרטי",
  lastName: "יש להזין שם משפחה",
  phoneNumber: "יש להזין מספר טלפון",
  licenseNumber: "יש להזין לוחית רישוי",
  licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
  modelId: "בחר דגם",
  area: "בחר איזור",
  skuOrName: "נא הכנס טקסט חופשי או מספר פריט",
}

export const regex = {
  numbers: /^[0-9]*$/,
  singleName: /^[a-zA-Zא-ת׳״ء-ي'"‘’\\.\-,\s]+$/u,
  fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
  name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
  phoneNumber: /^05(\d+-?)+\d+$/,
  licenseNumber:
    /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
  licenceOrChassis:
    /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/,
  cardNumber: /^[0-9 -?]+$/,
}

export const invalid = {
  numbers: "יש להזין ספרות בלבד",
  fullName: "שם מלא לא תקין",
  name: "יש להזין אותיות בעברית / אנגלית בלבד",
  email: "כתובת המייל אינה תקינה",
  phoneNumber: "*בבקשה לבדוק שהזנת מס׳ טלפון תקין",
  licenseNumber: "נא להזין מספר בעל 7-8 תווים המורכב מספרות בלבד",
  licenceOrChassis: "מספר רישוי או שילדה לא תקין",
}

export const schemaCommon = {
  phoneNumber: yup
    .string()
    .matches(regex.phoneNumber, "יש להזין מספר טלפון תקין")
    .required(required.default)
    .max(11, "יש להזין עד 10 ספרות בלבד"),
  firstName: yup
    .string()
    .trim()
    .matches(regex.singleName, "יש להזין אותיות בלבד")
    .min(2, "יש להזין לפחות שתי אותיות תחת השם")
    .max(50, "יש להזין עד 50 תווים בלבד")
    .required(required.default)
    .test(
      "not-only-spaces",
      "יש להזין שם שאינו ריק",
      (value) => !!value && value.trim().length > 0
    ),
  lastName: yup
    .string()
    .trim()
    .matches(regex.singleName, "יש להזין אותיות בלבד")
    .min(2, "יש להזין לפחות שתי אותיות תחת השם")
    .max(50, "יש להזין עד 50 תווים בלבד")
    .required(required.default)
    .test(
      "not-only-spaces",
      "יש להזין שם שאינו ריק",
      (value) => !!value && value.trim().length > 0
    ),
  fullName: yup
    .string()
    .trim()
    .matches(regex.fullName, "יש להזין אותיות בלבד")
    .required(required.default)
    .test(
      "not-only-spaces",
      "יש להזין שם שאינו ריק",
      (value) => !!value && value.trim().length > 0
    ),
  email: yup
    .string()
    .email("יש להזין כתובת מייל תקינה")
    .required(required.default),
  city: yup.string(),
  street: yup.string(),
  apartmentNumber: yup.string().matches(regex.numbers, invalid.numbers),
  floorNumber: yup.string().matches(regex.numbers, invalid.numbers),
  entranceNumber: yup.string().matches(regex.numbers, invalid.numbers),
  comments: yup.string().max(200, "ניתן להזין עד 200 תווים"),
  termsOfUseCheckbox: yup
    .boolean()
    .required("חובה להסכים לתנאי השימוש")
    .oneOf([true], "חובה להסכים לתנאי השימוש"),
  cardNumber: yup
    .string()
    .matches(regex.cardNumber, invalid.numbers)
    .required(required.default),
}
